<div class="w-full h-full flex flex-col py-6 px-6">
  <!-- Options bar -->
  <div class="flex items-end justify-between mb-3">
    <div class="flex items-center flex-wrap gap-4">
      <div *ngIf="scanners" class="w-[260px]">
        <mat-select class="filter-select" [formControl]="filterScanners" multiple placeholder="Filter by Scanner">
            <mat-option *ngFor="let scanner of scanners" [value]="scanner.Id">
            {{ scanner.Name }}
            </mat-option>
        </mat-select>
      </div>
      <div *ngIf="customers" class="w-[170px]">
        <mat-select class="filter-select" [formControl]="filterCustomers" multiple placeholder="Filter by Customer">
            <mat-option *ngFor="let customer of customers" [value]="customer.id">
            {{ customer.name }}
            </mat-option>
        </mat-select>
      </div>
      <div *ngIf="login_months" class="w-[190px]">
        <mat-select class="filter-select" [formControl]="filterLoginMonths" multiple placeholder="Filter by Login Month">
            <mat-option *ngFor="let month of login_months" [value]="month.id">
            {{ month.name }}
            </mat-option>
        </mat-select>
      </div>
      <div *ngIf="create_months" class="w-[190px]">
        <mat-select class="filter-select" [formControl]="filterCreateMonths" multiple placeholder="Filter by Create Month">
            <mat-option *ngFor="let month of create_months" [value]="month.id">
            {{ month.name }}
            </mat-option>
        </mat-select>
      </div>
      <div *ngIf="deactivate_months" class="w-[190px]">
        <mat-select class="filter-select" [formControl]="filterDeactivateMonths" multiple placeholder="Include Deactivations">
            <mat-option *ngFor="let month of deactivate_months" [value]="month.id">
            {{ month.name }}
            </mat-option>
        </mat-select>
      </div>
      <div *ngIf="filterCustomers.value?.includes('mta')" class="flex items-center gap-3">
        <input type="checkbox" class="w-5 h-5 dark-checkbox" [(ngModel)]="mtaOptionsCheck">
        <p class="text-sm text-white">Receiving options data</p>
      </div>
    </div>
    <div class="flex justify-end items-end dark:text-gray-300 text-sm">
        <button type="button" class="ml-2 dark-btn min-w-[125px]" (click)="clear_filters()">
          <i class="fa-solid fa-xmark mr-1 dark:text-green-600"></i> Clear Filters
        </button>
        <button type="button" class="ml-2 dark-btn min-w-[105px]" (click)="refresh()">
          <i class="fa-solid fa-fw fa-sync mr-1 dark:text-green-600"></i> Refresh
        </button>
    </div>
  </div>


  <!-- Grid -->
  <ag-grid-angular
    class="flex-1 w-full h-[600px]"
    [theme]="theme"
    [gridOptions]="grid.options"
    [columnDefs]="grid.columnDefs"
    [rowData]="data"
    [statusBar]="grid.statusBar"
    (gridReady)="on_grid_ready($event)"
    (modelUpdated)="on_model_updated($event)"
    (rowSelected)="on_row_selected($event)"
  />
</div>